import { render, staticRenderFns } from "./SkeletonIdLoader.vue?vue&type=template&id=05a1fcfd&scoped=true&"
import script from "./SkeletonIdLoader.vue?vue&type=script&lang=js&"
export * from "./SkeletonIdLoader.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonIdLoader.vue?vue&type=style&index=0&id=05a1fcfd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a1fcfd",
  null
  
)

export default component.exports